import { branding } from '@/config/branding';

export function useCompanyLogo() {
  return {
    logoLight: branding.logo.light,
    logoDark: branding.logo.dark,
    logoSvg: branding.logo.svg,
    logoIconLight: branding.logo.iconLight,
    logoIconDark: branding.logo.iconDark,
  };
}
